import React from 'react';
import { Box, Modal, ModalBody, ModalHeader } from '@razorpay/blade/components';
import { isYouTubeUrl, getYouTubeEmbedUrl } from './utils';

export type VideoModalProps = {
  isOpen: boolean;
  onDismiss: () => void;
  src: string;
};

const VideoModal = ({ isOpen, onDismiss, src }: VideoModalProps) => {
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} size={'medium'}>
      <ModalHeader />
      <ModalBody>
        <Box padding={'spacing.6'} marginTop={'spacing.3'}>
          {isYouTubeUrl(src) ? (
            <iframe
              width="100%"
              height="400"
              src={getYouTubeEmbedUrl(src)}
              title="YouTube video player"
              allowFullScreen
              data-testid="youtube-iframe"
            />
          ) : (
            <video 
              playsInline 
              controls 
              src={src} 
              data-testid="video-modal" 
              width="100%" 
            />
          )}
        </Box>
      </ModalBody>
    </Modal>
  );
};

export default VideoModal;
